import { ANDROID_PACKAGE, APP_SCHEME, PLAY_STORE_URL } from 'app/invite/invite.const';

/** 네이티브 앱 루트로 여는 딥링크. iOS / 기타 플랫폼에서 쓴다. */
export const buildAppRootDeepLink = (): string => `${APP_SCHEME}://`;

/**
 * 안드로이드용 intent URL. 앱이 설치돼 있지 않으면 S.browser_fallback_url 덕에 크롬이
 * Play 스토어로 보내주므로 별도 타이머 폴백이 필요 없다.
 */
export const buildAndroidAppRootIntentUrl = (): string =>
  `intent://#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(PLAY_STORE_URL)};end`;
